import PropTypes__default from 'prop-types';

const SelectionInputProps = PropTypes__default.shape({
  /** Input identification (must be unique on the page) */
  id: PropTypes__default.string.isRequired,
  /** Descriptive label for row selection input. */
  'aria-label': PropTypes__default.string.isRequired,
  /**
   * Value for selection input,
   * is returned on onChange callback with the input checked status.
   */
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
  /**
   * onChange callback for when a row selection status changes.
   * @param {object} selection - { value: string, selected: boolean }
   */
  onChange: PropTypes__default.func,
  /**
   * Sets initial selected state for table row
   */
  selected: PropTypes__default.bool
});
const CellContent = PropTypes__default.arrayOf(PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.number]));

export { CellContent, SelectionInputProps };
